import { render, staticRenderFns } from "./onlineNotice.vue?vue&type=template&id=508c4ff8&scoped=true&"
import script from "./onlineNotice.vue?vue&type=script&lang=js&"
export * from "./onlineNotice.vue?vue&type=script&lang=js&"
import style0 from "./onlineNotice.vue?vue&type=style&index=0&id=508c4ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c4ff8",
  null
  
)

export default component.exports